module.exports = __webpack_public_path__ + "static/7eyecatchingindiegamesPYG0-d9f28260e322b114a7ccc187d182ba7b.webp";